// extracted by mini-css-extract-plugin
export var wrapper = "styles-module--wrapper--3SGN6";
export var icon = "styles-module--icon--1KjBz";
export var text = "styles-module--text--27_q1";
export var cta = "styles-module--cta--3qwj5";
export var button = "styles-module--button--2hJ-_";